import { Component, TemplateRef, ViewChild } from '@angular/core';

import { UserLogoComponent } from '@camelot/ui';
import { TypedTemplateDirective } from '@camelot/utils';

import { User } from '../../services/dto/user';

@Component({
  selector: 'app-input-user-choice-template',
  templateUrl: './user-input-template.component.html',
  imports: [UserLogoComponent, TypedTemplateDirective],
})
export class InputChoiceTemplateComponent {
  @ViewChild('choiceTemplate', { static: true }) choiceTemplate!: TemplateRef<any>;

  readonly typeUserToken!: { item: User };

  getTemplate() {
    return this.choiceTemplate;
  }
}
